var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ElementRef, EventEmitter, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Listing } from '../../../classes/listing';
import { PreferencesService } from '../../../services/preferences.service';
import { ListingsService } from '../../../services/listings.service';
import { DeviceService } from '../../../services/device/device.service';
import { ADD_SAVED_LISTING_PAGE_GTM } from '../../../classes/analytics-tags';
import { SCREEN_SIZE } from '../../../classes/enums';
import { victoriaRealEstate, caraBoardPartialName, BritishColumbiaStateShort } from '../../../app-config.constants';
import { RoutingHistoryService } from '../../../services/routing-history.service';
var ListingSummaryComponent = /** @class */ (function () {
    function ListingSummaryComponent(_preferencesService, _listingService, deviceService, historyService) {
        this._preferencesService = _preferencesService;
        this._listingService = _listingService;
        this.deviceService = deviceService;
        this.historyService = historyService;
        this.listing = new Listing();
        this.mortgagePaymentAmount = '$0';
        this.hasNextListings = false;
        this.hasCopiedText = false;
        this.showExpandedGalleryView = false;
        this.showMap = false;
        this.isMortgageApplicable = false;
        this.SCREEN_SIZE = SCREEN_SIZE;
        this.BritishColumbiaStateShort = BritishColumbiaStateShort;
        this.disabled = false;
        this.previousListingClicked = new EventEmitter();
        this.nextListingClicked = new EventEmitter();
        this.showContactAgentClicked = new EventEmitter();
        this.showScheduleViewingClicked = new EventEmitter();
        this.goBack = new EventEmitter();
        this.toggleExpandedGalleryView = new EventEmitter();
        this.homeEstimateLinkClick = new EventEmitter();
        this.currentSlideIndex = 0; // Which index the carousel should start with, we need this to keep the expanded gallery view and the normal carousel in sync
        this.isVictoriaRealEstateBoard = false;
        this.isCaraBoard = false;
    }
    ListingSummaryComponent.prototype.ngOnInit = function () {
        this.backButton = this.listing.isLuxury ? '/assets/icons/general_navigation/Back_to_search_white.svg' : '/assets/icons/general_navigation/Back_to_search_blue.svg';
        this.isVictoriaRealEstateBoard = this.listing.boardName && this.listing.boardName.toLowerCase().indexOf(victoriaRealEstate) !== -1 && !this.listing.isRemaxListing;
        this.isCaraBoard = this.listing.boardName && this.listing.boardName.toLowerCase().indexOf(caraBoardPartialName) !== -1; //&& !this.listing.isRemaxListing;
    };
    ListingSummaryComponent.prototype.ngOnChanges = function (changes) {
        if (changes.listing) {
            this.currentSlideIndex = 0;
        }
    };
    ListingSummaryComponent.prototype.changeCarouselIndex = function (event) {
        this.currentSlideIndex = event;
        if (this.imageContainer && !this.deviceService.isSafariBrowser()) {
            this.imageContainer.nativeElement.children[event].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
    };
    ListingSummaryComponent.prototype.toggleFavourite = function ($event) {
        $event.stopPropagation();
        this.listing.isFavourite = !this.listing.isFavourite;
        this._preferencesService.toggleFavouriteListing(this.listing.listingId, ADD_SAVED_LISTING_PAGE_GTM);
        this.listing.getFavouriteIconToUse();
    };
    return ListingSummaryComponent;
}());
export { ListingSummaryComponent };
var ListingSummaryDesktopComponent = /** @class */ (function (_super) {
    __extends(ListingSummaryDesktopComponent, _super);
    function ListingSummaryDesktopComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListingSummaryDesktopComponent.prototype.navigateToForm = function () {
        this.toggleExpandedGalleryView.emit(false);
        if (this.listing.isLuxury) {
            this.showContactAgentClicked.emit();
        }
        else {
            // TODO: make this smooth
            var top_1 = document.getElementById('contact-form').offsetTop;
            // TODO: make the first input focused on the contact form
            document.getElementById('contact-form').scrollIntoView(true);
        }
    };
    return ListingSummaryDesktopComponent;
}(ListingSummaryComponent));
export { ListingSummaryDesktopComponent };
var ListingSummaryMobileComponent = /** @class */ (function (_super) {
    __extends(ListingSummaryMobileComponent, _super);
    function ListingSummaryMobileComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ListingSummaryMobileComponent;
}(ListingSummaryComponent));
export { ListingSummaryMobileComponent };
